/**
 * A sign-in screen exists ONLY on a studio's own address (owner, 2026-10-04).
 *
 * fitboxxone.com itself names no studio — the backend runs it on the shared
 * control-plane database — so it never shows a login. The member app (served
 * at the root) draws FitBOXX's own landing page there (owner, 2026-10-05);
 * the studio app hands over to it. It used to hand over to
 * saas-boxx.com/product/fitboxx, which is no longer open to the public. The
 * server refuses the sign-in itself there too
 * (apps/core/middleware.no_tenant_signin_refusal).
 */
const ROOT_DOMAIN = 'fitboxxone.com';
const LANDING_PAGE = `https://${ROOT_DOMAIN}/`;

export function isBareDomain(host: string = window.location.hostname): boolean {
  const h = host.toLowerCase();
  return h === ROOT_DOMAIN || h === `www.${ROOT_DOMAIN}`;
}

/** True when the page is leaving for the landing page — render nothing.
 *  Only for apps that are NOT the landing's own (the studio app): the member
 *  app draws the landing itself, so it must not call this. */
export function leaveBareDomain(): boolean {
  if (!isBareDomain()) return false;
  window.location.replace(LANDING_PAGE);
  return true;
}
